import React from 'react'
import {UsageHeader} from '@/ui/index'
import {UsageSummaryOrgPlanNew} from './org-level-usage/usageSummaryOrgPlanNew'
import {IfFeatureEnabled} from '@growthbook/growthbook-react'

export function UsageOrgHeader() {
  return (
    <>
      <UsageHeader />
      <IfFeatureEnabled feature="manage-org-level-usage">
        <UsageSummaryOrgPlanNew />
      </IfFeatureEnabled>
    </>
  )
}
